import { normalizeServiceRole, toMarketplaceServiceRoleId } from "./npidClient";

/** True when caregiver service role is physiotherapist / physio. */
export function isPhysioServiceRole(value) {
  return normalizeServiceRole(value) === "physiotherapist";
}

/**
 * Resolve service role from common API / profile shapes.
 */
export function resolveCaregiverServiceRole(source) {
  if (!source || typeof source !== "object") return null;
  const candidates = [
    source.serviceRole,
    source.service_role,
    source.marketplacePrefs?.serviceRole,
    source.profileExtended?.marketplacePrefs?.serviceRole,
    source.profile?.serviceRole,
    source.profile?.service_role,
    source.profile?.profileExtended?.marketplacePrefs?.serviceRole,
    source.onboarding?.serviceRole,
    source.onboarding?.service_role,
  ];
  for (const c of candidates) {
    if (c != null && String(c).trim()) return toMarketplaceServiceRoleId(c);
  }
  return null;
}

export function isPhysioFromProfile(source) {
  return isPhysioServiceRole(resolveCaregiverServiceRole(source));
}
